import axios, { AxiosInstance } from 'axios';

export function addMaintenanceInterceptor(instance: AxiosInstance): void {
    instance.interceptors.request.use((config) => {
        if (process.env.REACT_APP_IS_UNDER_MAINTENANCE === 'true') {
            return Promise.reject(new axios.CanceledError('maintenance'));
        }
        return config;
    });
}
